import { ColumnDef } from "@tanstack/react-table"
import React from "react"
import { TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import Icon from "../../../../../icon/icon.component"
import Image from "../../../../../image/image.component.jsx"

export default (): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const value = info.getValue() as string

        if (value) {
            return <Image imageId={value} size="very-small" />
        } else {
            return <Icon value={"image"} style={{ fontSize: "30px" }} />
        }
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/ImageCellMapper.tsx